<template>
  <div
    elevation="0"
    class="px-0"
    :class="$vuetify.theme.dark ? '' : 'grey lighten-3'"
  >
    <div class="d-flex flex-nowrap transparent px-2 align-center">
      <v-btn fab depressed class="transparent" small @click="[$router.go(-1)]">
        <v-icon size="24">mdi-chevron-left</v-icon>
      </v-btn>
      <v-breadcrumbs
        :items="items"
        class="pa-3 d-flex flex-nowrap text-truncate caption"
      ></v-breadcrumbs>
    </div>
    <v-divider></v-divider>
  </div>
</template>
<script>
export default {
  name: "breadcrumbs",
  data: () => ({
    items: [],
  }),
  mounted() {
    this._buildBreadcrumbs();
  },
  watch: {
    $route: function () {
      this._buildBreadcrumbs();
    },
  },
  methods: {
    async _buildBreadcrumbs() {
      const items = await this.$route.matched.map((element, index) => {
        return {
          text: element.meta.nameDrawer,
          disabled: index <= 1 ? true : true,
          href: element.path,
        };
      });
      this.items = items;
    },
  },
};
</script>